import { m as meaninglessTransform } from './meaninglessTransform-2ba19953.js';

/** Returns if the given transform object contains any non-default values */
const transformIsMeaningful = transform => transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
var transformIsMeaningful$1 = transformIsMeaningful;

export { transformIsMeaningful$1 as t };
//# sourceMappingURL=transformIsMeaningful-fde42595.js.map
